import { isOfflineMode } from "../shared/offlineManager";
import * as Sentry from "@sentry/react";
import { getNetworkInfo } from "./networkInfo";

export async function isReallyOnline() {
  if (isOfflineMode()) {
    const networkInfo = getNetworkInfo();
    Sentry.addBreadcrumb({
      message: "Network Error: Offline Mode",
      category: "Network Error",
      level: "info",
      data: {
        connectionType: networkInfo.type,
        effectiveType: networkInfo.effectiveType,
        downlink: networkInfo.downlink,
        rtt: networkInfo.rtt,
        saveData: networkInfo.saveData,
      },
    });
    return false; // manual offline mode
  }

  if (!navigator.onLine) {
    // Track when navigator.onLine is false
    const networkInfo = getNetworkInfo();
    Sentry.addBreadcrumb({
      message: "Network Error",
      category: "Network Error",
      level: "info",
      data: {
        connectionType: networkInfo.type,
        effectiveType: networkInfo.effectiveType,
        downlink: networkInfo.downlink,
        rtt: networkInfo.rtt,
        saveData: networkInfo.saveData,
      },
    });
    return false;
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 1000);

  try {
    const response = await fetch("https://www.google.com/generate_204", {
      method: "HEAD",
      mode: "no-cors",
      cache: "no-store",
      signal: controller.signal,
    });

    // "opaque" means the request went through but CORS prevented visibility
    return response.type === "opaque";
  } catch (error) {
    // Track when connectivity check fails with network info
    const networkInfo = getNetworkInfo();

    Sentry.addBreadcrumb({
      message: "isReallyOnline check: connectivity test failed",
      category: "Network Error",
      level: "warning",
      data: {
        error: error instanceof Error ? error.message : String(error),
        connectionType: networkInfo.type,
        effectiveType: networkInfo.effectiveType,
        downlink: networkInfo.downlink,
        rtt: networkInfo.rtt,
        saveData: networkInfo.saveData,
        navigatorOnLine: navigator.onLine,
      },
    });

    return false;
  } finally {
    clearTimeout(timeoutId);
  }
}
